<template>
  <div class="meetingSign">
    <div v-if="this.pageLoading" class="pageLoading">
      <van-loading type="spinner" />
    </div>
    <div v-else>
      <div v-if="this.isQRCodeOk">
        <div v-if="this.isShowScanTemplates">
          <NavBar
            :narBarTitle="this.curScanTemplate.barTitle"
            :hideArrow="true"
          />

          <van-form
            @submit="onSubmit"
            class="content"
            colon
            v-if="fieldname.length"
          >
            <van-field
              v-for="(item, index) in fieldname"
              :key="index"
              v-model="fieldvalue[index]"
              :name="item"
              :value="fieldvalue[index]"
              :label="item"
              :placeholder="$t('请输入')"
              :rules="[
                { required: true, message: $t('请填写{item}', { item: item }) },
              ]"
              :readonly="item === $t('姓名') || item === $t('部门')"
            />
            <div class="bottom" v-if="this.curScanTemplate.showSignInButton">
              <van-button
                round
                block
                type="info"
                class="signBtn"
                native-type="submit"
                :disabled="this.submitLoading"
                >{{ $t('签到') }}</van-button
              >
            </div>
          </van-form>
        </div>
        <div v-if="this.isShowSignInResult">
          <NavBar :narBarTitle="this.signInResult.barTitle" :hideArrow="true" />
          <div
            class="scanResultWrapper"
            v-if="this.signInResult.success.tipsInfo.title"
          >
            <img
              :src="require('@/assets/images/success.png')"
              alt=""
              class="tipsIcon"
            />
            <div class="tipsTitle">
              {{ this.signInResult.success.tipsInfo.title }}
            </div>
          </div>
          <div class="scanResultWrapper" v-else>
            <img
              :src="require('@/assets/images/error_big.png')"
              alt=""
              class="tipsIcon"
            />
            <div class="tipsTitle">
              {{ this.signInResult.error.tipsInfo.title }}
            </div>
            <div class="tipsContent">
              {{ this.signInResult.error.tipsInfo.content }}
            </div>
          </div>
        </div>
      </div>
      <div v-else>
        <NavBar :narBarTitle="this.scanResult.barTitle" :hideArrow="true" />
        <div class="scanResultWrapper">
          <img
            :src="require('@/assets/images/tips.png')"
            alt=""
            class="tipsIcon"
          />
          <div class="tipsTitle" v-if="this.scanResult.error.tipsInfo.title">
            {{ this.scanResult.error.tipsInfo.title }}
          </div>
          <div
            class="tipsContent"
            v-if="this.scanResult.error.tipsInfo.content"
          >
            {{ this.scanResult.error.tipsInfo.content }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import NavBar from '@/components/navBar'
import Vue from 'vue'
import { getCode, ifInDD } from '@/utils/getDingCode.js'
import {
  isQiWeiPlatform,
  isFeiShuPlatform,
  isNewworkAPPPlatform,
} from '@/utils/utils'
import {
  ovWxAutoLogin,
  getTemplateList,
  meetingSignIn,
  getAppointmentByID,
  getMeetingRoomConfig,
  queryMeetingSignIn,
  startMeeting,
} from '@/services/api'
import { Cell, CellGroup, Button, Form, Field, Toast, Loading } from 'vant'
import dayjs from 'dayjs'

Vue.use(Cell)
Vue.use(CellGroup)
Vue.use(Button)
Vue.use(Form)
Vue.use(Field)
Vue.use(Loading)

export default {
  name: 'SignIn',
  components: {
    NavBar,
  },
  data() {
    return {
      // 扫码二维码
      scanResult: {
        error: {
          barTitle: this.$t('扫码结果'),
          showSignInButton: false,
          tipsInfo: {
            title: this.$t('无法识别'),
            content: '',
          },
        },
      },
      // 扫码二维码的内容
      scanTemplates: [
        {
          type: 'meeting',
          content: {
            barTitle: this.$t('会议签到确认'),
            type: 'meetingSignIn',
            showSignInButton: true,
          },
        },
      ],

      // 签到内容
      signInResult: {
        barTitle: this.$t('签到结果'),
        success: {
          showSignInButton: false,
          tipsInfo: {
            title: '',
          },
        },
        error: {
          showSignInButton: false,
          tipsInfo: {
            title: '',
            content: '',
          },
        },
      },
      curScanTemplate: {
        barTitle: '',
        type: '',
        showSignInButton: false,
      },
      curResultTemplate: {},
      pageLoading: true, // 页面是否加载中
      isQRCodeOk: true, // 扫描的二维码是否正常
      isShowScanTemplates: false, // 是否显示签到模版信息
      isShowSignInResult: false, // 是否显示签到后到结果
      templateList: [], // 签到模版列表
      currentTemplate: {},
      curmTemplatefields: [],
      fieldname: [],
      fieldvalue: [],
      urlQueryData: {}, // 不同oa平台来的url参数
      submitLoading: false, // 签到按钮loading
      userInfo: {}, // 登录后的用户信息
      meetingInfo: {}, // 当前会议的详细信息
    }
  },
  methods: {
    getScanTemplate() {
      this.curScanTemplate = this.scanTemplates.find(
        (template) => template.type === 'meeting'
      )?.content
    },
    // 根据code换取用户信息
    async autoLogin(code, type) {
      // newwork app扫码时，本身已经是登录状态，无需再次登录
      if (type === 'NewWorkAPP') {
        const userInfo = window?.injectData?.userInfo
        this.userInfo = JSON.parse(userInfo)

        if (userInfo) {
          localStorage.setItem('user', userInfo)
          let companyCodeLocal = { code: JSON.parse(userInfo).companyCode }

          localStorage.setItem('cCode', JSON.stringify(companyCodeLocal))
          localStorage.setItem('companyCode', JSON.stringify(companyCodeLocal))
        }

        const isCanSign = await this.canSign()
        if (!isCanSign) {
          this.isQRCodeOk = false
          this.scanResult.error.tipsInfo.title = ''
          this.scanResult.error.tipsInfo.content = this.$t('不在会议签到时间内')
          this.pageLoading = false
          return
        }

        // 渲染签到模版
        await this.queryTemplateList()
        return
      }

      // 是个正确的二维码
      this.isQRCodeOk = true

      try {
        let res = {}
        if (type === 'DingDing') {
          res = await ovWxAutoLogin({
            companyCode: this.urlQueryData.companyCode,
            dingTalkUserId: code,
          })
        } else if (type === 'feishu') {
          res = await ovWxAutoLogin({
            companyCode: this.urlQueryData.companyCode,
            fsOpenId: code,
          })
        } else if (type === 'WXwork') {
          res = await ovWxAutoLogin({
            companyCode: this.urlQueryData.companyCode,
            qwWechatOpenId: code,
          })
        }

        if (res.id != -1) {
          this.userInfo = res

          localStorage.setItem('user', JSON.stringify(res))
          let companyCodeLocal = { code: this.urlQueryData.companyCode }

          localStorage.setItem('cCode', JSON.stringify(companyCodeLocal))
          localStorage.setItem('companyCode', JSON.stringify(companyCodeLocal))
        }
        const isCanSign = await this.canSign()
        if (!isCanSign) {
          this.isQRCodeOk = false
          this.scanResult.error.tipsInfo.title = ''
          this.scanResult.error.tipsInfo.content = this.$t('不在会议签到时间内')
          this.pageLoading = false
          return
        }

        // 渲染签到模版
        await this.queryTemplateList()
      } catch (error) {
        Toast(this.$t('用户登录失败！'))
      }
    },
    getScanWarningInfo(warningInfo) {
      this.isQRCodeOk = false
      this.scanResult.error.tipsInfo.content = warningInfo
      this.pageLoading = false
    },
    login() {
      const inDD = ifInDD()
      const inQW = isQiWeiPlatform()
      const infs = isFeiShuPlatform()
      const inNWAPP = isNewworkAPPPlatform()

      this.urlQueryData = {
        appointmentId: this.$route.query?.appointmentId,
        companyCode: this.$route.query?.companyCode,
      }

      if (this.$route.query?.oaType) {
        this.urlQueryData.oaType = this.$route.query?.oaType
        this.urlQueryData.signTemplateId = this.$route.query?.signTemplateId
        this.urlQueryData.companyCode = this.$route.query?.companyCode
      }

      // 针对企微单独进行处理：企微url只能将参数放到state里，其他多余key放的参数不生效
      const stateValue =
        this.$route.query?.state && this.$route.query?.state?.split(',')
      const isQWCode = stateValue && stateValue[0] === 'WXwork' //是否企微生成的二维码
      if (isQWCode) {
        this.urlQueryData.oaType = stateValue[0]
        this.urlQueryData.signTemplateId = stateValue[1]
        this.urlQueryData.companyCode = stateValue[2]
        this.urlQueryData.appointmentId = stateValue[3]
      }

      if (
        this.urlQueryData.oaType === 'DingDing' ||
        this.urlQueryData.oaType === 'feishu' ||
        this.urlQueryData.oaType === 'WXwork' ||
        this.urlQueryData.oaType === 'NewWorkAPP'
      ) {
        // 二维码格式正确，在针对不同oa类型进行处理

        if (inNWAPP) {
          // 在Newwork app中，默认支持钉钉、企微、飞书二维码直接打开，无需进行登录换取token
          this.autoLogin('', 'NewWorkAPP')
        } else {
          // 在非Newwork app中，需要按照不同的oa客户端进行自动登录获取用户信息

          if (this.urlQueryData.oaType === 'DingDing') {
            // 钉钉自动登录
            this.urlQueryData.corpid = this.$route.query?.corpid

            if (!inDD) {
              this.getScanWarningInfo(
                this.$t('请使用钉钉或NewWork APP扫码签到')
              )
              return
            }

            getCode((code) => {
              this.autoLogin(code, 'DingDing')
            }, this.urlQueryData.corpid)
          } else if (this.urlQueryData.oaType === 'feishu') {
            // 飞书自动登录
            this.urlQueryData.fsAppId = this.$route.query.fsAppId

            if (!infs) {
              this.getScanWarningInfo(
                this.$t('请使用飞书或NewWork APP扫码签到')
              )
              return
            }

            if (!window.h5sdk) {
              console.log('invalid h5sdk')
              return
            }

            window.h5sdk.ready(() => {
              // ready方法不需要每次都调用
              tt.requestAuthCode({
                appId: this.urlQueryData.fsAppId,
                success: (info) => {
                  console.log('feishu-info', info)
                  this.autoLogin(info.code, 'feishu')
                },
                fail: (error) => {
                  console.error('feishu-error', error)
                },
              })
            })
          } else if (this.urlQueryData.oaType === 'WXwork') {
            // 企微自动登录
            this.urlQueryData.fsAppId = this.$route.query.fsAppId
            this.urlQueryData.code = this.$route.query.code

            if (!inQW) {
              this.getScanWarningInfo(
                this.$t('请使用企业微信或NewWork APP扫码签到')
              )
              return
            }

            this.autoLogin(this.urlQueryData.code, 'WXwork')
          } else if (this.urlQueryData.oaType === 'NewWorkAPP') {
            // NewWorkAPP
            if (!inNWAPP) {
              this.getScanWarningInfo(this.$t('请使用NewWorkAPP客户端扫码签到'))
              return
            }

            this.autoLogin('', 'NewWorkAPP')
          }
        }
      } else {
        // 二维码格式不正确，无法识别
        this.getScanWarningInfo()
      }
    },
    async queryTemplateList() {
      const data = {}
      const user = JSON.parse(localStorage.getItem('user'))
      if (user.companyId) {
        data['developerId'] = user.companyId
        data['companyId'] = user.companyId
        try {
          const res = await getTemplateList(data)

          this.pageLoading = false

          this.templateList = res ?? []
          this.currentTemplate =
            res.find((item) => item.id == this.urlQueryData.signTemplateId) ??
            {}
          this.fieldname = this.currentTemplate?.field?.split(',') ?? []

          // 模版没有部门和姓名的情况，也会存在姓名和部门顺序不一致。需要key按照顺序赋值
          // 姓名和部门在签到页面自动显示，只显示，不能编辑
          const fieldNameIndex = this.fieldname.findIndex(
            (v) => v == this.$t('姓名')
          )
          const fieldDepartmentNameIndex = this.fieldname.findIndex(
            (v) => v == this.$t('部门')
          )
          fieldNameIndex !== -1 && (this.fieldvalue[fieldNameIndex] = user.name)
          fieldDepartmentNameIndex !== -1 &&
            (this.fieldvalue[fieldDepartmentNameIndex] = user.departmentName)

          // this.fieldvalue = [user.name, user.departmentName]
          this.isShowSignInResult = false
          this.isShowScanTemplates = true
        } catch (error) {
          this.pageLoading = false
        }
      }
    },
    // 是否可以签到
    async canSign() {
      // 根据会议状态和时间，判断是否支持签到：会议准备中-结束前，期间是可以签到；未开始，又不是准备中的会议，不能签到
      const curTime = dayjs()
      // const meetingInfo = await getAppointmentByID({ appointmentId: 21189 }) // 获取当前会议信息
      const meetingInfo = await getAppointmentByID({
        appointmentId: this.urlQueryData.appointmentId,
      }) // 获取当前会议信息

      this.meetingInfo = meetingInfo

      // 会议是否准备中
      const isReadyMeeting =
        curTime.isBetween(
          dayjs(meetingInfo.appointmentStartTime).subtract(
            meetingInfo.signBeforeMinute ? meetingInfo.signBeforeMinute : 10,
            'minute'
          ),
          dayjs(meetingInfo.appointmentStartTime)
        ) &&
        !meetingInfo.actualStartTime &&
        !meetingInfo.actualEndTime

      // 是否在签到的时间范围内
      const isInSignTime =
        meetingInfo.state !== 'complete' &&
        meetingInfo.state !== 'cancel' &&
        !meetingInfo.actualEndTime &&
        ((meetingInfo.actualStartTime &&
          curTime.isBetween(
            dayjs(meetingInfo.actualStartTime),
            dayjs(meetingInfo.appointmentEndTime)
          )) ||
          (!meetingInfo.actualStartTime &&
            curTime.isBetween(
              dayjs(meetingInfo.appointmentStartTime),
              dayjs(meetingInfo.appointmentEndTime)
            )))

      // 是否可以签到
      return (
        (isReadyMeeting || isInSignTime) &&
        meetingInfo?.staffName != this.$t('临时人员') &&
        meetingInfo?.staffName != 'Temporary Worker'
      )
    },
    async onSubmit() {
      const isCanSign = await this.canSign()
      if (!isCanSign) {
        this.isQRCodeOk = false
        this.scanResult.error.tipsInfo.title = ''
        this.scanResult.error.tipsInfo.content = this.$t('不在会议签到时间内')
        this.pageLoading = false
        return
      }

      this.submitLoading = true

      const remark = {}
      this.fieldname?.forEach((name, idx) => {
        remark[name] = this.fieldvalue[idx]
      })
      console.log('remark', remark)

      try {
        // 如果是第一个签到的定会人或者参会人，直接开始会议
        let isSignPeopleOk = false // 是否定会人或事参会人
        this.meetingInfo.meetingPeopleId.split(',').forEach((peopleId) => {
          if (peopleId == this.userInfo.id) {
            isSignPeopleOk = true
          }
        })

        if (!isSignPeopleOk) {
          this.signInResult.error.tipsInfo.title = this.$t('签到失败')
          this.signInResult.error.tipsInfo.content =
            this.$t('非本次会议参会人无法签到，请确认信息')
          this.submitLoading = false
          this.isShowScanTemplates = false
          this.isShowSignInResult = true
          return
        }
        // 获取当前会议的签到历史
        const historySignMeetings = await queryMeetingSignIn({
          pageNum: 1,
          pageSize: 1000,
          meetingId: this.urlQueryData.appointmentId,
        })

        await meetingSignIn({
          meetingId: this.urlQueryData.appointmentId,
          staffId: this.userInfo.id,
          remark: JSON.stringify(remark),
        })

        if (isSignPeopleOk) {
          // 签到记录为空时，访客进行开始会议
          if (
            historySignMeetings?.results?.length === 0 &&
            this.meetingInfo.sign
          ) {
            // 第一个人签到的话,直接开始会议
            await startMeeting({
              appointmentId: this.urlQueryData.appointmentId,
              mobile: this.userInfo.mobile,
              source: 'qrCode',
            })
          }
        }

        this.signInResult.success.tipsInfo.title = this.$t('成功签到')
        this.isShowScanTemplates = false
        this.isShowSignInResult = true
        this.submitLoading = false
      } catch (error) {
        console.log('---error:', error?.response?.data?.message)
        this.signInResult.error.tipsInfo.title = this.$t('签到失败')
        this.signInResult.error.tipsInfo.content =
          error?.response?.data?.message
        this.submitLoading = false
        this.isShowScanTemplates = false
        this.isShowSignInResult = true
      }
    },
  },
  mounted() {
    this.getScanTemplate()
    this.login()
  },
}
</script>
<style lang="less" scoped>
.meetingSign {
  .pageLoading {
    position: absolute;
    left: 50%;
    top: 50%;
    margin-top: -16px;
    margin-left: -16px;
  }

  .content {
    .van-cell {
      padding: 16px;
    }

    .van-field__label {
      span {
        font-family: PingFangSC, PingFang SC;
        font-weight: 400;
        font-size: 16px;
        color: #b7bdc6;
        flex: none;
      }
    }

    .van-cell__value {
      font-family: PingFangSC, PingFang SC;
      font-weight: 400;
      font-size: 16px;
      color: #1e2329;
      flex: none;
    }
  }

  .bottom {
    position: fixed;
    bottom: 16px;
    width: 100%;

    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;

    .signBtn {
      width: 335px;
      height: 48px;
      background: #167aff;
      border-radius: 24px;

      .van-button__text {
        font-family: PingFangSC, PingFang SC;
        font-weight: 500;
        font-size: 16px;
        color: #ffffff;
      }
    }
  }

  .scanResultWrapper {
    margin-top: 122px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    .tipsIcon {
      width: 36px;
      height: 36px;
    }

    .tipsTitle {
      font-family: PingFangSC, PingFang SC;
      font-weight: 500;
      font-size: 20px;
      color: #1e2329;
      margin-top: 4px;
    }

    .tipsContent {
      margin-top: 10px;
      font-family: PingFangSC, PingFang SC;
      font-weight: 400;
      font-size: 14px;
      color: #474d57;
    }
  }
}
</style>
